import { AIProvider } from '../types/ai';
import { Assistant } from '../types/assistant';

interface MobileInitialScreenProps {
  availableProviders: AIProvider[];
  assistants: Assistant[];
  onProviderSelect: (providerId: string, modelId: string) => void;
  onAssistantSelect: (assistant: Assistant) => void;
  onCreateAssistant: () => void;
  onMenuClick: () => void;
}

export function MobileInitialScreen({ 
  availableProviders,
  assistants,
  onProviderSelect,
  onAssistantSelect,
  onCreateAssistant,
  onMenuClick 
}: MobileInitialScreenProps) {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Top Bar */}
      <div className="bg-white shadow-sm border-b px-4 py-2 flex items-center justify-between">
        <button
          onClick={onMenuClick}
          className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
        >
          <svg className="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
        
        <img src="/space-logo-black.png" alt="SPACE" className="h-8 object-contain" />
        
        <div className="w-10"></div> {/* Spacer para centralizar o logo */}
      </div>

      {/* Main Content */}
      <div className="p-4">
        <div className="text-center mb-6">
          <h2 className="text-xl font-semibold text-gray-900">
            Escolha sua IA
          </h2>
        </div>

        {/* AI Providers Grid - No topo */}
        <div className="mb-8">
          <div className="grid grid-cols-3 gap-4">
            {availableProviders.map((provider) => (
              <button
                key={provider.id}
                onClick={() => onProviderSelect(provider.id, provider.models[0].id)}
                className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 text-center hover:shadow-md transition-all"
              >
                <div className="flex flex-col items-center space-y-3">
                  <div className="w-16 h-16 rounded-lg bg-gray-100 flex items-center justify-center flex-shrink-0">
                    {provider.id === 'openai' && (
                      <img src="/gpt-logo.png" alt="GPT" className="w-10 h-10 object-contain" />
                    )}
                    {provider.id === 'anthropic' && (
                      <img src="/claude-logo.png" alt="Claude" className="w-10 h-10 object-contain" />
                    )}
                    {provider.id === 'google' && (
                      <img src="/gemini-logo.png" alt="Gemini" className="w-10 h-10 object-contain" />
                    )}
                    {!['openai', 'anthropic', 'google'].includes(provider.id) && (
                      <span className="text-gray-600 text-2xl">🤖</span>
                    )}
                  </div>
                  <h3 className="font-medium text-gray-900 text-sm">{provider.name}</h3>
                </div>
              </button>
            ))}
          </div>
        </div>

        {/* Assistants Section - Embaixo */}
        <div>
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-lg font-semibold text-gray-900">Seus Agentes</h3>
            <button
              onClick={onCreateAssistant}
              className="flex items-center space-x-1 bg-blue-600 text-white px-3 py-1.5 rounded-lg text-sm font-medium hover:bg-blue-700 transition-colors"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
              </svg>
              <span>Criar</span>
            </button>
          </div>
          
          {assistants.length > 0 ? (
            <>
              <div className="grid grid-cols-2 gap-3">
              {assistants.slice(0, 6).map((assistant) => (
                <button
                  key={assistant.id}
                  onClick={() => onAssistantSelect(assistant)}
                  className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 text-center hover:shadow-md transition-all"
                >
                  <div className="flex flex-col items-center space-y-2">
                    <div className="w-12 h-12 rounded-lg bg-gray-100 flex items-center justify-center text-2xl">
                      {assistant.avatar || '🤖'}
                    </div>
                    <h4 className="font-medium text-gray-900 text-sm truncate w-full">{assistant.name}</h4>
                  </div>
                </button>
              ))}
            </div>
              {assistants.length > 6 && (
                <div className="text-center mt-3">
                  <p className="text-sm text-gray-500">+{assistants.length - 6} agentes no menu</p>
                </div>
              )}
            </>
          ) : (
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8 text-center">
              <div className="text-4xl mb-3">🤖</div>
              <p className="text-gray-600 text-sm mb-3">
                Nenhum agente criado ainda
              </p>
              <p className="text-gray-500 text-xs">
                Crie seu primeiro agente personalizado!
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
